import React from "react";
import { PageHero } from "../components/Sections";
import { Card } from "../components/ui/card";
import { LeadForm } from "../components/LeadForm";
import { useSettings } from "../context/SettingsContext";
import { Phone, Mail, MapPin, Clock, ShieldAlert } from "lucide-react";

export default function Contact() {
  const { settings } = useSettings();
  const info = [
    { icon: Phone, label: "Phone", value: settings.phone || "[Telephone]" },
    { icon: Mail, label: "Email", value: settings.email || "[Official Email]" },
    { icon: MapPin, label: "Registered Office", value: settings.address || "[Registered Office Address]" },
    { icon: Clock, label: "Customer Support", value: settings.support_contact || "As per stated support hours" },
  ];
  return (
    <div>
      <PageHero title="Get in Touch"
        subtitle="Have a question or need assistance? Send us your details and our team will reach out."
        crumbs={[{ label: "Contact Us" }]} />
      <section className="section-pad">
        <div className="container-page grid gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold">Contact Information</h2>
            <p className="mt-2 text-muted-foreground">
              Reach us using the details below. For complaints, please visit our Grievance Redressal page.
            </p>
            <div className="mt-8 space-y-4">
              {info.map((i) => (
                <Card key={i.label} className="flex items-center gap-4 border p-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary">
                    <i.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{i.label}</div>
                    <div className="font-medium">{i.value}</div>
                  </div>
                </Card>
              ))}
            </div>
            <div className="mt-6 flex items-start gap-2 rounded-xl border border-primary/20 bg-secondary/50 p-4 text-sm text-muted-foreground">
              <ShieldAlert className="h-5 w-5 shrink-0 text-primary" />
              We collect only need-based information and process it in accordance with our Privacy Policy.
            </div>
          </div>
          <Card className="border p-6 md:p-8 shadow-sm">
            <h3 className="font-heading text-xl font-bold">Send an enquiry</h3>
            <p className="mt-1 text-sm text-muted-foreground">Fields marked * are required.</p>
            <div className="mt-6"><LeadForm /></div>
          </Card>
        </div>
      </section>
    </div>
  );
}
